import { FlexBox } from '@dixa/lib-shared-habla';
import { memo } from 'react';

import { SearchAgentQuickFilter } from './components/agent/searchAgentQuickFilter';
import { SearchChannelQuickFilter } from './components/channel/searchChannelQuickFilter';
import { SearchContactQuickFilter } from './components/contact/searchContactQuickFilter';
import { SearchDirectionQuickFilter } from './components/direction/searchDirectionQuickFilter';
import { SearchQueueQuickFilter } from './components/queue/searchQueueQuickFilter';
import { SearchStatusQuickFilter } from './components/status/searchStatusQuickFilter';

export const SearchQuickFilters = memo(
  function SearchQuickFilters(): JSX.Element {
    return (
      <FlexBox flexWrap="wrap" alignItems="center" justifyContent="flex-end">
        <SearchDirectionQuickFilter />
        <SearchAgentQuickFilter />
        <SearchContactQuickFilter />
        <SearchChannelQuickFilter />
        <SearchQueueQuickFilter />
        <SearchStatusQuickFilter />
      </FlexBox>
    );
  },
);
